import { render } from "./BarChart.vue?vue&type=template&id=b0f23b34&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=b0f23b34&lang=scss&scoped=true"
import "./BarChart.vue?vue&type=style&index=1&id=b0f23b34&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f23b34"]])

export default __exports__